export enum STOP_CASTING_TEST_IDS {
    DISCONNECT = 'disconnect',
}
